import { Box, FormHelperText, InputLabel } from '@mui/material'
import {
  DateTimePickerProps,
  DateTimePicker as MuiDateTimePicker,
} from '@mui/x-date-pickers'
import { theme } from 'Providers/ThemeProvider'
import { DATETIME_FORMAT } from 'constans/common'
import { Dayjs } from 'dayjs'

export interface IDateTimePickerProps extends DateTimePickerProps<Dayjs> {
  width?: string | number
  helperText?: string
  error?: boolean
  formatString?: string
}

const DateTimePicker = ({
  label,
  width = '100%',
  helperText,
  formatString = DATETIME_FORMAT,
  error = false,
  ...rest
}: IDateTimePickerProps) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <InputLabel
        sx={theme => ({
          color: theme.palette.common.black,
          fontWeight: 400,
          fontSize: 12,
        })}
        id="input-label"
      >
        {label}
      </InputLabel>
      <MuiDateTimePicker
        sx={{
          width,
          '& > div': {
            height: 40,
          },
          '& fieldset': {
            border: `solid 1px ${
              error ? theme.palette.error.main : '#0000003b'
            }`,
          },
        }}
        format={formatString}
        {...rest}
      />
      {helperText && (
        <FormHelperText error={error}>{helperText}</FormHelperText>
      )}
    </Box>
  )
}

export default DateTimePicker
